export const ENTITLEMENTS_INVALIDATED_EVENT = "chessla:entitlements-invalidated";
export const invalidateEntitlements = (): void => {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(ENTITLEMENTS_INVALIDATED_EVENT));
};
